/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RegisterField } from './register-field';
import { ProgramConfig } from './program-config';


export interface Program { 
    id: string;
    name: string;
    parentId: string;
    slug: string;
    integration: Program.IntegrationEnum;
    contactEmail: string;
    consentOptInUrl: string;
    balanceNotifications: boolean;
    balanceNotificationsMessage: string;
    tierNotifications: boolean;
    tierNotificationsMessage: string;
    rewardAvailableNotifications: boolean;
    rewardAvailableNotificationsMessage: string;
    locationNotifications: boolean;
    marketingNotifications: boolean;
    configurations: ProgramConfig;
    downloadEmail: boolean;
    verifyEmail: boolean;
    redeemRewardEmail: boolean;
    couponAssignedEmail: boolean;
    rewardRedeemableEmail: boolean;
    defaultLanguage: string;
    enabledLanguages: Array<string>;
    nfcEnabled: boolean;
    barcodeFormat: Program.BarcodeFormatEnum;
    registerFields: Array<RegisterField>;
    notificationsPriority: Array<Program.NotificationsPriorityEnum>;
    consolidatePushesWithAi: boolean;
    currency: string;
    shopifyCustomerAccountsVersion: Program.ShopifyCustomerAccountsVersionEnum | null;
    shopifyInstalledChannels: Array<string> | null;
    /**
     * Whether the Shopify shop is on Shopify Plus. Null until first read from Shopify.
     */
    shopifyPlus: boolean | null;
    /**
     * Shopify plan display name (e.g. \"Shopify Plus\", \"Developer Preview\").
     */
    shopifyPlanName: string | null;
    shouldShowPaymentModal: boolean;
    partner: string;
    createdAt: string;
    updatedAt: string;
}
export namespace Program {
    export const IntegrationEnum = {
        Api: 'api',
        Convercus: 'convercus',
        Jericommerce: 'jericommerce',
        Klaviyo: 'klaviyo',
        ShopifyLoyaltyLion: 'shopify/loyalty-lion',
        Mcp: 'mcp',
        Shopify: 'shopify',
        Vtap: 'vtap',
        Idtech: 'idtech'
    } as const;
    export type IntegrationEnum = typeof IntegrationEnum[keyof typeof IntegrationEnum];
    export const BarcodeFormatEnum = {
        Qr: 'qr',
        Barcode: 'barcode'
    } as const;
    export type BarcodeFormatEnum = typeof BarcodeFormatEnum[keyof typeof BarcodeFormatEnum];
    export const NotificationsPriorityEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3
    } as const;
    export type NotificationsPriorityEnum = typeof NotificationsPriorityEnum[keyof typeof NotificationsPriorityEnum];
    export const ShopifyCustomerAccountsVersionEnum = {
        Classic: 'CLASSIC',
        NewCustomerAccounts: 'NEW_CUSTOMER_ACCOUNTS'
    } as const;
    export type ShopifyCustomerAccountsVersionEnum = typeof ShopifyCustomerAccountsVersionEnum[keyof typeof ShopifyCustomerAccountsVersionEnum];
}


